const ArrowRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
    >
      <path fillRule="evenodd" clipRule="evenodd" d="M15.7634 12.5534C16.0789 12.2478 16.0789 11.7522 15.7634 11.4466L10.3788 6.22922C10.0634 5.92359 9.55199 5.92359 9.23657 6.22922C8.92114 6.53485 8.92114 7.03037 9.23657 7.336L14.0501 12L9.23657 16.664C8.92115 16.9696 8.92115 17.4652 9.23657 17.7708C9.55199 18.0764 10.0634 18.0764 10.3788 17.7708L15.7634 12.5534Z" fill="currentColor"/>
    </svg>
  )
}

export default ArrowRight;
